// extracted by mini-css-extract-plugin
export default {"Social":"Social_Social__s5cDo"};